<template>
  <sec-section>
    <!-- Pale-blue banner across the full width: the offer and its button on the left, the
         "Why it works this way" note as a white card on the right (stacked on phones). -->
    <sec-panel quiet class="pricing">
      <div class="pricing__grid">
        <div class="pricing__lead">
          <p class="o700 sec-eyebrow">{{ pricing.eyebrow }}</p>
          <h2 class="o600 sec-h2">{{ pricing.title }}</h2>
          <p class="m500 sec-body-lg pricing__text">{{ pricing.text }}</p>
          <sec-actions :actions="pricing.actions" />
        </div>
        <aside class="pricing__note">
          <v-icon class="pricing__note-icon" size="26" aria-hidden="true">mdi-tag-text-outline</v-icon>
          <p class="m500 pricing__note-text"><sec-rich :value="pricing.note" /></p>
        </aside>
      </div>
    </sec-panel>
  </sec-section>
</template>

<script setup>
import SecSection from '@/components/security/ui/SecSection.vue';
import SecPanel from '@/components/security/ui/SecPanel.vue';
import SecActions from '@/components/security/ui/SecActions.vue';
import SecRich from '@/components/security/ui/SecRich.vue';
import { SERVICES } from '@/content/security/services';

const pricing = SERVICES.pricing;
</script>

<style scoped>
.pricing__grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--sec-s4);
  align-items: center;
}

.pricing__lead {
  display: flex;
  flex-direction: column;
  gap: var(--sec-s3);
  min-width: 0;
}

.pricing__text {
  color: var(--sec-ink-2);
}

.pricing__note {
  display: flex;
  flex-direction: column;
  gap: var(--sec-s2);
  padding: 1.75rem;
  background: var(--sec-surface);
  border-radius: var(--sec-radius-card);
  box-shadow: 0 18px 36px -24px var(--sec-header-shadow);
}

.pricing__note-icon {
  color: var(--sec-accent-text);
}

.pricing__note-text {
  font-size: 1.0625rem;
  line-height: 1.65;
  color: var(--sec-ink-2);
}

.pricing__note-text :deep(b) {
  color: var(--sec-ink);
}

@media only screen and (min-width: 700px) {
  .sec-panel.pricing {
    padding: 3rem;
  }
  .pricing__note {
    padding: 2.25rem;
  }
}

@media only screen and (min-width: 960px) {
  .pricing__grid {
    grid-template-columns: minmax(0, 1.15fr) minmax(0, 1fr);
    gap: 4rem;
  }
}
</style>
